<template>
    <div class="Page">
        <Header Act="5"></Header>
        <div class="MaxWid">
            <div class="MarTop">
                <div class="AboutPos">当前位置：继续教育</div>
                <div class="AboutDis">
                    <div class="AboutNav">
                        <div class="AboutNavItem" v-for="item in Data" :key="item.id" :class="{Act:i==item.id}" @click="TogglePage(item.id)"><i class="iconfont" :class="{[item.icon]:true}"></i>{{item.name}}</div>
                    </div>
                    <div class="AboutCont">
                        <div class="QueryContItem" v-for="item in Cont" :key="item.id">
                            <div class="QueryContItemTit" @click="GoDetail(item)">
                                <div class="iconfont icon-shujidaoru"></div>
                                <div>{{ item.title }}</div>
                            </div>
                        </div>
                        <div v-if="!Cont || !Cont.length" class="EmptyTip">暂无已发布的项目</div>
                        <div class="PageDis">
                            <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"  @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page" :hide-on-single-page="false"></el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import Banner from '@/components/banner/Banner';
    export default {
        components: {Header,Footer,Banner},
        data() {
            return {
                i:'',
                Data: "",
                Cont:"",
                total:0,
                page:1,
                SizePage:10,
                TypeId: 2,
            }
        },
        mounted() {
            this.GetData();
        },
        methods: {
            GetData() {
                this.$get("api/index/getJoinInGroup",{
                   type:this.TypeId,
               }).then(res => {
                    if(res.data.code == 1){
                        this.Data = res.data.data;
                        this.GetCont(this.Data[0].id)
                    }
                })
            },
            GetCont(id){
                const groupId = id || this.i;
                this.Cont = "";
                this.$post("api/index/projectsList",{
                    user_group_id:groupId,
                    page:this.page,
                    limit:this.SizePage,
                }).then(res => {
                    if(res.data.code == 1){
                        this.i = groupId;
                        this.total = res.data.data.total;
                        this.Cont = res.data.data.data;
                    }
               })
            },
            TogglePage(id){
                this.page = 1;
                this.GetCont(id);
            },
            SizeChange(val) {
                this.SizePage = val;
                this.page = 1;
                this.GetCont();
            },
            PageChange(val) {
                this.page = val;
                this.GetCont();
            },
            GoDetail(item) {
                this.$router.push({
                    path: '/education/detail',
                    query: { id: item.id }
                });
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }

    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
    }
    .AboutDis{
        display: flex;
        margin-bottom: 30px;
    }
    .AboutNav{
        width: 250px;
        background: #0385EB;
        flex-shrink: 0;
    }
    .AboutNavItem{
        padding: 15px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .AboutNavItem:hover,
    .AboutNavItem.Act{
        background: #fff;
        color: #0385EB;
    }
    .AboutNavItem .iconfont{
        font-size: 22px;
        margin-right: 10px;
    }
    .AboutCont{
        flex: 1;
        max-width: 900px;
        overflow: auto;
        margin-left: 20px;
    }
    .QueryContItem{
        margin-bottom: 12px;
    }
    .QueryContItemTit{
        padding: 15px;
        color: #fff;
        font-size: 18px;
        background: #0286eb;
        display: flex;
        cursor: pointer;
    }
    .QueryContItemTit .iconfont{
        margin-right: 10px;
    }
    .EmptyTip{
        padding: 40px 0;
        text-align: center;
        color: #999;
        font-size: 15px;
    }
    .PageDis{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }
    @media only screen and (max-width: 550px){
        .AboutDis{
            display: block;
            margin-bottom: 30px;
        }
        .AboutNav{
            width: 100%;
            display: flex;
            margin-bottom: 20px;
        }
        .AboutNavItem{
            padding: 15px 0;
            font-size: 16px;
            text-align: center;
            flex: 1;
        }
        .AboutNavItem .iconfont{
            display: none;
        }
        .AboutCont{
            margin: 0;
            max-width: none;
        }
    }
</style>
